import { configureStore } from '@reduxjs/toolkit';
import { exposeApi } from '../services/expose-api';
import { modernizationButtonVisibilityApi } from '../services/modernization-button-visibility-api';

export const store = configureStore({
  reducer: {
    [exposeApi.reducerPath]: exposeApi.reducer,
    [modernizationButtonVisibilityApi.reducerPath]: modernizationButtonVisibilityApi.reducer,
  },
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([exposeApi.middleware, modernizationButtonVisibilityApi.middleware]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
